import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Star, CheckCircle, ShoppingBag } from 'lucide-react';
import { motion } from 'framer-motion';
import { products, profileData } from '../data/mockData';
import { ProductCard } from '../components/ProductCard';
export function StorePreview() {
  const navigate = useNavigate();
  const activeProducts = products.filter(p => p.status === 'approved');
  return <div className="min-h-screen pb-10" data-id="element-399">
      <div className="max-w-md mx-auto" data-id="element-400">
        {/* Header */}
        <div className="flex items-center gap-4 p-5 pt-8" data-id="element-401">
          <button onClick={() => navigate('/profile')} className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-white hover:bg-white/[0.08] transition-colors" data-id="element-402">
            <ArrowLeft className="w-5 h-5" data-id="element-403" />
          </button>
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-404">
            Store Preview
          </h1>
        </div>

        <div className="px-5 space-y-6" data-id="element-405">
          {/* Store Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="glass-card relative overflow-hidden" data-id="element-406">
            {/* Cover gradient */}
            <div className="h-24 bg-gradient-to-br from-[#00D68F]/30 to-[#00B377]/10 relative" data-id="element-407">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1511512578047-dfb367046420?w=600&h=200&fit=crop&q=60')] bg-cover bg-center opacity-20" data-id="element-408" />
            </div>

            <div className="px-6 pb-6 -mt-12 relative z-10" data-id="element-409">
              <div className="flex items-end gap-4 mb-4" data-id="element-410">
                <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-[#00D68F] to-[#00B377] flex items-center justify-center text-[#0A0E1A] text-3xl font-bold ring-4 ring-[#0A0E1A] shadow-[0_0_20px_rgba(0,214,143,0.3)]" data-id="element-411">
                  {profileData.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div className="flex-1 pb-1" data-id="element-412">
                  <div className="flex items-center gap-2" data-id="element-413">
                    <h2 className="text-white text-xl font-bold tracking-tight" data-id="element-414">
                      {profileData.name}
                    </h2>
                    <div className="w-5 h-5 rounded-full bg-[#00D68F] flex items-center justify-center" data-id="element-415">
                      <CheckCircle className="w-3.5 h-3.5 text-[#0A0E1A]" data-id="element-416" />
                    </div>
                  </div>
                  <div className="flex items-center gap-3 mt-1" data-id="element-417">
                    <div className="flex items-center gap-1" data-id="element-418">
                      <Star className="w-4 h-4 text-[#FFBE0B] fill-[#FFBE0B]" data-id="element-419" />
                      <span className="text-white font-bold text-sm" data-id="element-420">
                        {profileData.rating}
                      </span>
                    </div>
                    <span className="text-[#64748B] text-xs" data-id="element-421">•</span>
                    <span className="text-[#64748B] text-xs font-medium" data-id="element-422">
                      {profileData.totalSales} sales
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3" data-id="element-423">
                <div className="flex items-center gap-1.5 bg-[#00D68F]/10 px-3 py-1.5 rounded-full border border-[#00D68F]/20" data-id="element-424">
                  <CheckCircle className="w-3.5 h-3.5 text-[#00D68F]" data-id="element-425" />
                  <span className="text-[#00D68F] font-bold text-xs" data-id="element-426">
                    Verified Seller
                  </span>
                </div>
                <div className="flex items-center gap-1.5 bg-white/[0.04] px-3 py-1.5 rounded-full border border-white/[0.06]" data-id="element-427">
                  <ShoppingBag className="w-3.5 h-3.5 text-[#64748B]" data-id="element-428" />
                  <span className="text-[#64748B] font-bold text-xs" data-id="element-429">
                    {activeProducts.length} Products
                  </span>
                </div>
              </div>
            </div>

            <div className="px-6 pb-4 pt-3 border-t border-white/[0.06]" data-id="element-430">
              <p className="text-label text-center" data-id="element-431">
                👁 Public Storefront View — How buyers see your store
              </p>
            </div>
          </motion.div>

          {/* Products Grid */}
          <div data-id="element-432">
            <h3 className="text-label mb-4" data-id="element-433">Available Products</h3>
            <div className="grid grid-cols-2 gap-3" data-id="element-434">
              {activeProducts.map((product, index) => <motion.div key={product.id} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: index * 0.05
            }} data-id="element-435">
                  <ProductCard product={product} compact data-id="element-436" />
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}